import React, { useEffect, useState } from "react";
import axios from "axios";
import UserBankinfo from "./UserBankinfo";
import { baseUrl } from "../../../enum/constant";


const AdminBankinfo = ({ fiatSymbol, current_transactionType, activeTab }) => {
  const [bankInfoList, setBankInfoList] = useState([]);

  useEffect(() => {
    // Check if fiatSymbol is either 'USD' or 'EUR', then fetch corresponding data
    const fetchBankInfo = async () => {
      try {
        const base = baseUrl;
        const url = `${base}api/bank-info/${fiatSymbol}-currency`;
        const response = await axios.get(url);
        setBankInfoList(
          Array.isArray(response.data) ? response.data : [response.data]
        ); // Ensure it's an array
      } catch (error) {
        console.error("Error fetching bank info:", error);
      }
    };

    if (fiatSymbol) {
      fetchBankInfo();
    }
  }, [fiatSymbol]); // Dependency array ensures the effect runs whenever fiatSymbol changes
  useEffect(() => {
    // Here, you can use the activeTab to render or perform actions based on the active tab value.
    // console.log("Current active tab:", activeTab);
    // For example, load different bank info or adjust the behavior of the component
  }, [activeTab]);

  return (
    <>
      {/* <h1><strong>Conversion Type:</strong> {current_transactionType}</h1>  */}
      {current_transactionType === 'Sell' || activeTab === 'sell' ? (
        <UserBankinfo />
      ) : (
        <>
          <div className="col-md-6">
            {bankInfoList.length > 0 ? (
              <div className="inner-box">
                <h3>Bank details</h3>
                {bankInfoList.map((info, index) => (
                  <div className="b-details-box bg-gray100">
                    <div className="box">
                      <span>Company name</span>
                      <p>{info.company_name}</p>
                      <span>Company address</span>
                      <p>{info.company_address}</p>
                    </div>
                    <hr />
                    <div className="box">
                      <span>Bank name</span>
                      <p>{info.bank_name}</p>
                      <span>Bank address</span>
                      <p>{info.bank_address}</p>
                      <span>Account number</span>
                      <p>{info.account_number}</p>
                      <span>Reference field</span>
                      <p>{info.reference_field}</p>
                      <span>BIC/Swift</span>
                      <p>{info.bic_swift}</p>
                      <span>Supported payments</span>
                      <p>{info.supported_payments}</p>
                    </div>

                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center">No data available.</p>
            )}
          </div>
        </>
      )}

    </>
  );
};

export default AdminBankinfo;
